/**
 * Postgres `timestamptz::text` looks like "2026-09-15 14:12:12.826597+00":
 * space separator, microseconds, and a two-digit zone — none of which
 * `Date` accepts. Normalise to ISO ("...T14:12:12.826+00:00"), and treat a
 * missing zone as UTC.
 */
export const listedAtMs = (value?: string | null) => {
	if (!value) return 0
	let iso = value.trim().replace(' ', 'T')
	// Fractional seconds: keep at most milliseconds.
	iso = iso.replace(/(\.\d{3})\d+/, '$1')
	const zone = iso.match(/([+-]\d\d)(:?(\d\d))?$|[zZ]$/)
	if (!zone) iso = `${iso}Z`
	else if (zone[1] && !zone[3]) iso = `${iso}:00`
	else if (zone[1] && zone[3] && !zone[2].startsWith(':'))
		iso = iso.replace(/([+-]\d\d)(\d\d)$/, '$1:$2')
	const ms = new Date(iso).getTime()
	return Number.isFinite(ms) ? ms : 0
}
